




















import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class EdrLeftNav extends Vue {
  @Prop()
  private cState: any;
  /**
   * @description 跳转名医验案
   */
  private jumpPatientList() {
    this.$router.push({
      path: "/main/edr/patient-list",
      query: {
        project_id: this.$route.query.project_id
      }
    });
  }
  /**
   * @description 跳转模板管理
   */
  private jumpMobanguanli() {
    this.$router.push({
      path: "/main/edr/moban-list",
      query: {
        project_id: this.$route.query.project_id
      }
    });
  }
}
